import React, { ReactElement } from 'react';
import { Grid } from '@material-ui/core';
import useStyle from './styles';

interface IActionsRowProps {
  id: string;
  title: string;
  // eslint-disable-next-line react/require-default-props
  onOpenUpdateDrawer?: (titleId: string) => void;
}

export const ActionsRow = ({
  id,
  title,
  onOpenUpdateDrawer,
}: IActionsRowProps): ReactElement => {
  const classes = useStyle();

  return (
    <Grid container spacing={0}>
      <Grid item xs={12}>
        <a
          href={`${window.origin}/#/titlesContent?title=${id}`}
          rel="noopener noreferrer"
          onClick={() => onOpenUpdateDrawer?.(id)}
          className={classes.titleLink}
        >
          {title}
        </a>
      </Grid>
    </Grid>
  );
};
